export default {
  title: 'Enable notifications for exclusive deals & updates',
  description: 'Get order updates in real time. Track delivery status. Exclusive promos & perks.',
  buttons: {
    confirm: 'Enable',
    cancel: 'Not now',
  },
};
